import React, { createContext, useState, useContext, useEffect, useRef } from "react";

const AuthContext = createContext();
const SESSION_TIMEOUT_MS = 30 * 60 * 1000; // 30 minutes

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children, navigate }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [role, setRole] = useState('');
  const [authLoading, setAuthLoading] = useState(true);
  const timerRef = useRef(null);

  const clearSession = () => {
    setIsAuthenticated(false);
    setRole('');
    localStorage.removeItem("vrvToken");
    localStorage.removeItem('vrvEmail');
    localStorage.removeItem('vrvRole');
    localStorage.removeItem('vrvName');
    localStorage.removeItem('vrvSurname');
  };

  const resetTimer = () => {
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      clearSession();
      window.location.href = '/login';
    }, SESSION_TIMEOUT_MS);
  };

  // Start/stop activity listeners based on auth state
  useEffect(() => {
    if (!isAuthenticated) { clearTimeout(timerRef.current); return; }
    const events = ['click', 'keydown', 'scroll', 'mousemove', 'touchstart'];
    events.forEach(e => window.addEventListener(e, resetTimer));
    resetTimer();
    return () => {
      clearTimeout(timerRef.current);
      events.forEach(e => window.removeEventListener(e, resetTimer));
    };
  }, [isAuthenticated]); // eslint-disable-line

  useEffect(() => {
    const token = localStorage.getItem("vrvToken");
    if (token) {
      setIsAuthenticated(true);
      setRole(localStorage.getItem("vrvRole") || '');
    }
    setAuthLoading(false);
  }, []);

  const login = (token, email, userRole, userName, userSurname) => {
    localStorage.setItem("vrvToken", token);
    localStorage.setItem("vrvEmail", email);
    localStorage.setItem("vrvRole", userRole || '');
    if (userName) localStorage.setItem("vrvName", userName);
    if (userSurname) localStorage.setItem("vrvSurname", userSurname);
    setIsAuthenticated(true);
    setRole(userRole || '');
  };

  const logout = () => {
    clearTimeout(timerRef.current);
    clearSession();
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, authLoading, role, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};